import React from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

class ButtonCancel extends React.Component<React.HTMLProps<HTMLAnchorElement> & InjectedIntlProps> {
    public render() {
        const { className, children, ...otherProps } = this.props;
        const newClassName = `btn btn-primary ${className}`;
        const newChildren = children ? children : this.props.intl.formatMessage({id: 'common.cancel'});
        return (
            <a className={newClassName} {...otherProps}>{newChildren}</a>
        );
    }
}

export default compose(
    injectIntl,
)(ButtonCancel);



// WEBPACK FOOTER //
// ./src/components/Form/ButtonCancel.tsx